import { GrowthBook } from '@growthbook/growthbook'

export const growthbook = new GrowthBook({
  clientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY,
  apiHost: 'https://cdn.growthbook.io',
  enableDevMode: __DEV__,
  debug: __DEV__,
})

void growthbook.init({ streaming: true })
